import { useEffect, useState } from "react";
import { fetchCmlCardData } from "../../../api/homeApi";
import { toast } from "react-toastify";

function useFetchTopCmls(filter) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await fetchCmlCardData(filter);
        setData(response); // assuming response has a `data` field
      } catch (err) {
        toast.error("Cannot fetch CMLs with Highest CR");
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [JSON.stringify(filter)]); 
  return { data, loading, error };
}

export default useFetchTopCmls;
